[
  {
    "id": "living_01_default_theme_1_wallpaper_b",
    "name_jp": "しましま壁紙",
    "name_en": "Striped Wallpaper",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_1"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 1,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_1_wallpaper_c",
    "name_jp": "しましま壁紙",
    "name_en": "Striped Wallpaper",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_1"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 1,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_2_floor_b",
    "name_jp": "板張りの床",
    "name_en": "Wooden Flooring",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_2"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 2,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_2_floor_c",
    "name_jp": "板張りの床",
    "name_en": "Wooden Flooring",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_2"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 2,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_3_above_fireplace_b",
    "name_jp": "レトロなテレビ",
    "name_en": "Vintage TV",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_3"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 3,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_3_above_fireplace_c",
    "name_jp": "レトロなテレビ",
    "name_en": "Vintage TV",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_3"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 3,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_3_empty_na",
    "name_jp": "かたづける",
    "name_en": "Organizer",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_3"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 3,
    "max_tier": 2,
    "color": "na",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_4_empty_na",
    "name_jp": "かたづける",
    "name_en": "Organizer",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_4"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 4,
    "max_tier": 2,
    "color": "na",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_4_painting_b",
    "name_jp": "落書き風の絵画",
    "name_en": "Graffiti Painting",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_4"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 4,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_4_painting_c",
    "name_jp": "落書き風の絵画",
    "name_en": "Graffiti Painting",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_4"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 4,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_5_fireplace_b",
    "name_jp": "ぬくもり暖炉",
    "name_en": "Warm Fireplace",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_5"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 5,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_5_fireplace_c",
    "name_jp": "ぬくもり暖炉",
    "name_en": "Warm Fireplace",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_5"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 5,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_6_empty_na",
    "name_jp": "かたづける",
    "name_en": "Organizer",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_6"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 6,
    "max_tier": 2,
    "color": "na",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_6_tree_b",
    "name_jp": "ハートのなる木",
    "name_en": "Heart Tree",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_6"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 6,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_6_tree_c",
    "name_jp": "ハートのなる木",
    "name_en": "Heart Tree",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_6"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 6,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_7_couch_b",
    "name_jp": "シングルソファ",
    "name_en": "Single Sofa",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_7"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 7,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_7_couch_c",
    "name_jp": "シングルソファ",
    "name_en": "Single Sofa",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_7"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 7,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_7_empty_na",
    "name_jp": "かたづける",
    "name_en": "Organizer",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_7"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 7,
    "max_tier": 2,
    "color": "na",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_8_empty_na",
    "name_jp": "かたづける",
    "name_en": "Organizer",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_8"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 8,
    "max_tier": 2,
    "color": "na",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_8_sidetable_b",
    "name_jp": "サイドテーブル",
    "name_en": "Side Table",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_8"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 8,
    "max_tier": 2,
    "color": "b",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 1,
    "image": "01_living_room/01_default_theme/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_01_default_theme_8_sidetable_c",
    "name_jp": "サイドテーブル",
    "name_en": "Side Table",
    "tags": ["no_gacha", "living", "01_default_theme", "slot_8"],
    "room": "living",
    "theme": "01_default_theme",
    "slot": 8,
    "max_tier": 2,
    "color": "c",
    "release_date": "2021-10-23T15:00:00.000Z",
    "priority": 2,
    "image": "01_living_room/01_default_theme/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 0
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_a",
    "name_jp": "わくわく壁紙",
    "name_en": "Exciting Wallpaper",
    "tags": ["living", "02_surprise_birthday", "slot_1"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_b",
    "name_jp": "わくわく壁紙",
    "name_en": "Exciting Wallpaper",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_1"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_c",
    "name_jp": "わくわく壁紙",
    "name_en": "Exciting Wallpaper",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_1"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_2_floor_a",
    "name_jp": "ときめく床マット",
    "name_en": "Heart Floor Mat",
    "tags": ["living", "02_surprise_birthday", "slot_2"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_02_surprise_birthday_2_floor_b",
    "name_jp": "ときめく床マット",
    "name_en": "Heart Floor Mat",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_2"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_02_surprise_birthday_2_floor_c",
    "name_jp": "ときめく床マット",
    "name_en": "Heart Floor Mat",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_2"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_a",
    "name_jp": "ハート詰め合わせ",
    "name_en": "Heart Assortment",
    "tags": ["living", "02_surprise_birthday", "slot_3"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_b",
    "name_jp": "ハート詰め合わせ",
    "name_en": "Heart Assortment",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_3"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_c",
    "name_jp": "ハート詰め合わせ",
    "name_en": "Heart Assortment",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_3"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_02_surprise_birthday_4_painting_a",
    "name_jp": "ハートの絵画",
    "name_en": "Heart Painting",
    "tags": ["living", "02_surprise_birthday", "slot_4"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_4_painting_b",
    "name_jp": "ハートの絵画",
    "name_en": "Heart Painting",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_4"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_4_painting_c",
    "name_jp": "ハートの絵画",
    "name_en": "Heart Painting",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_4"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_a",
    "name_jp": "リボンの出窓",
    "name_en": "Ribbon Window",
    "tags": ["living", "02_surprise_birthday", "slot_5"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_b",
    "name_jp": "リボンの出窓",
    "name_en": "Ribbon Window",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_5"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_c",
    "name_jp": "リボンの出窓",
    "name_en": "Ribbon Window",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_5"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_02_surprise_birthday_6_tree_a",
    "name_jp": "びっくり風船",
    "name_en": "Surprise Balloon",
    "tags": ["living", "02_surprise_birthday", "slot_6"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_02_surprise_birthday_6_tree_b",
    "name_jp": "びっくり風船",
    "name_en": "Surprise Balloon",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_6"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_02_surprise_birthday_6_tree_c",
    "name_jp": "びっくり風船",
    "name_en": "Surprise Balloon",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_6"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_02_surprise_birthday_7_couch_a",
    "name_jp": "クマのぬいぐるみ",
    "name_en": "Bear Plush",
    "tags": ["living", "02_surprise_birthday", "slot_7"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_02_surprise_birthday_7_couch_b",
    "name_jp": "クマのぬいぐるみ",
    "name_en": "Bear Plush",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_7"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_02_surprise_birthday_7_couch_c",
    "name_jp": "クマのぬいぐるみ",
    "name_en": "Bear Plush",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_7"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_a",
    "name_jp": "謎のプレゼント",
    "name_en": "Mystery Gift",
    "tags": ["living", "02_surprise_birthday", "slot_8"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 3,
    "image": "01_living_room/02_surprise_birthday/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_b",
    "name_jp": "謎のプレゼント",
    "name_en": "Mystery Gift",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_8"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 4,
    "image": "01_living_room/02_surprise_birthday/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_c",
    "name_jp": "謎のプレゼント",
    "name_en": "Mystery Gift",
    "tags": ["no_gacha", "living", "02_surprise_birthday", "slot_8"],
    "room": "living",
    "theme": "02_surprise_birthday",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 5,
    "image": "01_living_room/02_surprise_birthday/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_a",
    "name_jp": "キャンプ壁紙",
    "name_en": "Camp Wallpaper",
    "tags": ["living", "03_starry_night_camp", "slot_1"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_b",
    "name_jp": "キャンプ壁紙",
    "name_en": "Camp Wallpaper",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_1"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_c",
    "name_jp": "キャンプ壁紙",
    "name_en": "Camp Wallpaper",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_1"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_2_floor_a",
    "name_jp": "キャンプマット",
    "name_en": "Camp Mat",
    "tags": ["living", "03_starry_night_camp", "slot_2"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_03_starry_night_camp_2_floor_b",
    "name_jp": "キャンプマット",
    "name_en": "Camp Mat",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_2"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_03_starry_night_camp_2_floor_c",
    "name_jp": "キャンプマット",
    "name_en": "Camp Mat",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_2"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_a",
    "name_jp": "らんらんランタン",
    "name_en": "Lantern",
    "tags": ["living", "03_starry_night_camp", "slot_3"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_b",
    "name_jp": "らんらんランタン",
    "name_en": "Lantern",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_3"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_c",
    "name_jp": "らんらんランタン",
    "name_en": "Lantern",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_3"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_03_starry_night_camp_4_painting_a",
    "name_jp": "ネイティブ柄",
    "name_en": "Native Print",
    "tags": ["living", "03_starry_night_camp", "slot_4"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_4_painting_b",
    "name_jp": "ネイティブ柄",
    "name_en": "Native Print",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_4"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_4_painting_c",
    "name_jp": "ネイティブ柄",
    "name_en": "Native Print",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_4"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_a",
    "name_jp": "ほっとコーヒー",
    "name_en": "Hot Coffee",
    "tags": ["living", "03_starry_night_camp", "slot_5"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_b",
    "name_jp": "ほっとコーヒー",
    "name_en": "Hot Coffee",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_5"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_c",
    "name_jp": "ほっとコーヒー",
    "name_en": "Hot Coffee",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_5"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_03_starry_night_camp_6_tree_a",
    "name_jp": "さぼらないサボテン",
    "name_en": "Non-stop Cactus",
    "tags": ["living", "03_starry_night_camp", "slot_6"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_03_starry_night_camp_6_tree_b",
    "name_jp": "さぼらないサボテン",
    "name_en": "Non-stop Cactus",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_6"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_03_starry_night_camp_6_tree_c",
    "name_jp": "さぼらないサボテン",
    "name_en": "Non-stop Cactus",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_6"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_03_starry_night_camp_7_couch_a",
    "name_jp": "ミニテント",
    "name_en": "Mini Tent",
    "tags": ["living", "03_starry_night_camp", "slot_7"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_03_starry_night_camp_7_couch_b",
    "name_jp": "ミニテント",
    "name_en": "Mini Tent",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_7"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_03_starry_night_camp_7_couch_c",
    "name_jp": "ミニテント",
    "name_en": "Mini Tent",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_7"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_a",
    "name_jp": "コーヒーポット",
    "name_en": "Coffee Pot",
    "tags": ["living", "03_starry_night_camp", "slot_8"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 6,
    "image": "01_living_room/03_starry_night_camp/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_b",
    "name_jp": "コーヒーポット",
    "name_en": "Coffee Pot",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_8"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 7,
    "image": "01_living_room/03_starry_night_camp/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_c",
    "name_jp": "コーヒーポット",
    "name_en": "Coffee Pot",
    "tags": ["no_gacha", "living", "03_starry_night_camp", "slot_8"],
    "room": "living",
    "theme": "03_starry_night_camp",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 8,
    "image": "01_living_room/03_starry_night_camp/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_a",
    "name_jp": "はなはな壁紙",
    "name_en": "Flower Wallpaper",
    "tags": ["living", "04_spring_flower_humming", "slot_1"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_b",
    "name_jp": "はなはな壁紙",
    "name_en": "Floral Wallpaper",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_1"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_c",
    "name_jp": "はなはな壁紙",
    "name_en": "Floral Wallpaper",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_1"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_a",
    "name_jp": "おはなのマット",
    "name_en": "Flower Mat",
    "tags": ["living", "04_spring_flower_humming", "slot_2"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_b",
    "name_jp": "おはなのマット",
    "name_en": "Flower Mat",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_2"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_c",
    "name_jp": "おはなのマット",
    "name_en": "Flower Mat",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_2"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_a",
    "name_jp": "おはな詰め合わせ",
    "name_en": "Flower Assortment",
    "tags": ["living", "04_spring_flower_humming", "slot_3"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_b",
    "name_jp": "おはな詰め合わせ",
    "name_en": "Flower Assortment",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_3"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_c",
    "name_jp": "おはな詰め合わせ",
    "name_en": "Flower Assortment",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_3"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_a",
    "name_jp": "おはなと音符",
    "name_en": "Flower & Note",
    "tags": ["living", "04_spring_flower_humming", "slot_4"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_b",
    "name_jp": "おはなと音符",
    "name_en": "Flower & Note",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_4"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_c",
    "name_jp": "おはなと音符",
    "name_en": "Flower & Note",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_4"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_a",
    "name_jp": "おはなの見える窓",
    "name_en": "Window with Flowers",
    "tags": ["living", "04_spring_flower_humming", "slot_5"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_b",
    "name_jp": "おはなの見える窓",
    "name_en": "Window with Flowers",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_5"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_c",
    "name_jp": "おはなの見える窓",
    "name_en": "Window with Flowers",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_5"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_a",
    "name_jp": "とーてむ",
    "name_en": "Totem",
    "tags": ["living", "04_spring_flower_humming", "slot_6"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_b",
    "name_jp": "とーてむ",
    "name_en": "Totem",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_6"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_c",
    "name_jp": "とーてむ",
    "name_en": "Totem",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_6"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_a",
    "name_jp": "おはなピアノ",
    "name_en": "Flower Piano",
    "tags": ["living", "04_spring_flower_humming", "slot_7"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_b",
    "name_jp": "おはなピアノ",
    "name_en": "Flower Piano",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_7"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_c",
    "name_jp": "おはなピアノ",
    "name_en": "Flower Piano",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_7"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_a",
    "name_jp": "おはなギター",
    "name_en": "Flower Guitar",
    "tags": ["living", "04_spring_flower_humming", "slot_8"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 9,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_b",
    "name_jp": "おはなギター",
    "name_en": "Flower Guitar",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_8"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 10,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_c",
    "name_jp": "おはなギター",
    "name_en": "Flower Guitar",
    "tags": ["no_gacha", "living", "04_spring_flower_humming", "slot_8"],
    "room": "living",
    "theme": "04_spring_flower_humming",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-10-31T15:00:00.000Z",
    "priority": 11,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_a",
    "name_jp": "うすもやの壁紙",
    "name_en": "Light Wallpaper",
    "tags": ["living", "05_forrest_friends", "slot_1"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_b",
    "name_jp": "うすもやの壁紙",
    "name_en": "Light Wallpaper",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_1"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_c",
    "name_jp": "うすもやの壁紙",
    "name_en": "Light Wallpaper",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_1"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_2_floor_a",
    "name_jp": "みどりの床マット",
    "name_en": "Green Floor Mat",
    "tags": ["living", "05_forrest_friends", "slot_2"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_05_forrest_friends_2_floor_b",
    "name_jp": "みどりの床マット",
    "name_en": "Green Floor Mat",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_2"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_05_forrest_friends_2_floor_c",
    "name_jp": "みどりの床マット",
    "name_en": "Green Floor Mat",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_2"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_a",
    "name_jp": "ピヨたち",
    "name_en": "Chirping Birds",
    "tags": ["living", "05_forrest_friends", "slot_3"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_b",
    "name_jp": "ピヨたち",
    "name_en": "Chirping Birds",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_3"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_c",
    "name_jp": "ピヨたち",
    "name_en": "Chirping Birds",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_3"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_05_forrest_friends_4_painting_a",
    "name_jp": "みどりの壁掛け",
    "name_en": "Green Wall Decor",
    "tags": ["living", "05_forrest_friends", "slot_4"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_4_painting_b",
    "name_jp": "みどりの壁掛け",
    "name_en": "Green Wall Decor",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_4"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_4_painting_c",
    "name_jp": "みどりの壁掛け",
    "name_en": "Green Wall Decor",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_4"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_a",
    "name_jp": "森が呼んでる",
    "name_en": "Forest Calling",
    "tags": ["living", "05_forrest_friends", "slot_5"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_b",
    "name_jp": "森が呼んでる",
    "name_en": "Forest Calling",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_5"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_c",
    "name_jp": "森が呼んでる",
    "name_en": "Forest Calling",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_5"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_05_forrest_friends_6_tree_a",
    "name_jp": "友だちいっぱいツリー",
    "name_en": "Friendship Tree",
    "tags": ["living", "05_forrest_friends", "slot_6"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_05_forrest_friends_6_tree_b",
    "name_jp": "友だちいっぱいツリー",
    "name_en": "Friendship Tree",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_6"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_05_forrest_friends_6_tree_c",
    "name_jp": "友だちいっぱいツリー",
    "name_en": "Friend Tree",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_6"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_05_forrest_friends_7_couch_a",
    "name_jp": "おさるのぬいぐるみ",
    "name_en": "Monkey Plush",
    "tags": ["living", "05_forrest_friends", "slot_7"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_05_forrest_friends_7_couch_b",
    "name_jp": "おさるのぬいぐるみ",
    "name_en": "Monkey Plush",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_7"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_05_forrest_friends_7_couch_c",
    "name_jp": "おさるのぬいぐるみ",
    "name_en": "Monkey Plush",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_7"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_a",
    "name_jp": "きのこたち",
    "name_en": "Mushroom Set",
    "tags": ["living", "05_forrest_friends", "slot_8"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 12,
    "image": "01_living_room/05_forrest_friends/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_b",
    "name_jp": "きのこたち",
    "name_en": "Mushroom Set",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_8"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 13,
    "image": "01_living_room/05_forrest_friends/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_c",
    "name_jp": "きのこたち",
    "name_en": "Mushroom Set",
    "tags": ["no_gacha", "living", "05_forrest_friends", "slot_8"],
    "room": "living",
    "theme": "05_forrest_friends",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-23T15:00:00.000Z",
    "priority": 14,
    "image": "01_living_room/05_forrest_friends/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_a",
    "name_jp": "クリスマス壁紙",
    "name_en": "Christmas Wallpaper",
    "tags": ["living", "06_happy_xmas", "slot_1"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_b",
    "name_jp": "クリスマス壁紙",
    "name_en": "Christmas Wallpaper",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_1"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_c",
    "name_jp": "クリスマス壁紙",
    "name_en": "Christmas Wallpaper",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_1"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_2_floor_a",
    "name_jp": "クリスマスマット",
    "name_en": "Christmas Mat",
    "tags": ["living", "06_happy_xmas", "slot_2"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_06_happy_xmas_2_floor_b",
    "name_jp": "クリスマスマット",
    "name_en": "Christmas Mat",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_2"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_06_happy_xmas_2_floor_c",
    "name_jp": "クリスマスマット",
    "name_en": "Christmas Mat",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_2"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_a",
    "name_jp": "クリスマスキャンディー",
    "name_en": "Christmas Candy",
    "tags": ["living", "06_happy_xmas", "slot_3"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_b",
    "name_jp": "クリスマスキャンディー",
    "name_en": "Christmas Candy",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_3"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_c",
    "name_jp": "クリスマスキャンディー",
    "name_en": "Christmas Candy",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_3"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_06_happy_xmas_4_painting_a",
    "name_jp": "クリスマスリース",
    "name_en": "Christmas Wreath",
    "tags": ["living", "06_happy_xmas", "slot_4"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_4_painting_b",
    "name_jp": "クリスマスリース",
    "name_en": "Christmas Wreath",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_4"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_4_painting_c",
    "name_jp": "クリスマスリース",
    "name_en": "Christmas Wreath",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_4"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_a",
    "name_jp": "クリスマス暖炉",
    "name_en": "Christmas Fireplace",
    "tags": ["living", "06_happy_xmas", "slot_5"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_b",
    "name_jp": "クリスマス暖炉",
    "name_en": "Christmas Fireplace",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_5"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_c",
    "name_jp": "クリスマス暖炉",
    "name_en": "Christmas Fireplace",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_5"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_06_happy_xmas_6_tree_a",
    "name_jp": "クリスマスツリー",
    "name_en": "Christmas Tree",
    "tags": ["living", "06_happy_xmas", "slot_6"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_06_happy_xmas_6_tree_b",
    "name_jp": "クリスマスツリー",
    "name_en": "Christmas Tree",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_6"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_06_happy_xmas_6_tree_c",
    "name_jp": "クリスマスツリー",
    "name_en": "Christmas Tree",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_6"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_06_happy_xmas_7_couch_a",
    "name_jp": "クリスマスソファ",
    "name_en": "Christmas Sofa",
    "tags": ["living", "06_happy_xmas", "slot_7"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_06_happy_xmas_7_couch_b",
    "name_jp": "クリスマスソファ",
    "name_en": "Christmas Sofa",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_7"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_06_happy_xmas_7_couch_c",
    "name_jp": "クリスマスソファ",
    "name_en": "Christmas Sofa",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_7"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_a",
    "name_jp": "プレゼントたち",
    "name_en": "Gifts",
    "tags": ["living", "06_happy_xmas", "slot_8"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 15,
    "image": "01_living_room/06_happy_xmas/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_b",
    "name_jp": "プレゼントたち",
    "name_en": "Gifts",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_8"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 16,
    "image": "01_living_room/06_happy_xmas/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_c",
    "name_jp": "プレゼントたち",
    "name_en": "Gift Decor",
    "tags": ["no_gacha", "living", "06_happy_xmas", "slot_8"],
    "room": "living",
    "theme": "06_happy_xmas",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-11-30T15:00:00.000Z",
    "priority": 17,
    "image": "01_living_room/06_happy_xmas/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_a",
    "name_jp": "格子柄の壁紙",
    "name_en": "Grid Wallpaper",
    "tags": ["living", "07_trad_japanese_winter", "slot_1"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_b",
    "name_jp": "格子柄の壁紙",
    "name_en": "Grid Wallpaper",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_1"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_c",
    "name_jp": "格子柄の壁紙",
    "name_en": "Grid Wallpaper",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_1"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_a",
    "name_jp": "雪道床マット",
    "name_en": "Snow Floor Mat",
    "tags": ["living", "07_trad_japanese_winter", "slot_2"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_b",
    "name_jp": "雪道床マット",
    "name_en": "Snow Floor Mat",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_2"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_c",
    "name_jp": "雪道床マット",
    "name_en": "Snow Floor Mat",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_2"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_a",
    "name_jp": "紅白テレビ",
    "name_en": "Red-White TV",
    "tags": ["living", "07_trad_japanese_winter", "slot_3"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_b",
    "name_jp": "紅白テレビ",
    "name_en": "Red-White TV",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_3"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_c",
    "name_jp": "紅白テレビ",
    "name_en": "Red-White TV",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_3"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_a",
    "name_jp": "ぶるぶる掛け軸",
    "name_en": "Scroll Painting",
    "tags": ["living", "07_trad_japanese_winter", "slot_4"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_b",
    "name_jp": "ぶるぶる掛け軸",
    "name_en": "Scroll Painting",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_4"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_c",
    "name_jp": "ぶるぶる掛け軸",
    "name_en": "Scroll Painting",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_4"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_a",
    "name_jp": "障子の向こうは",
    "name_en": "Beyond Shoji",
    "tags": ["living", "07_trad_japanese_winter", "slot_5"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_b",
    "name_jp": "障子の向こうは",
    "name_en": "Beyond Shoji",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_5"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_c",
    "name_jp": "障子の向こうは",
    "name_en": "Beyond Shoji",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_5"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_a",
    "name_jp": "ゆきだるまたち",
    "name_en": "Snowmen",
    "tags": ["living", "07_trad_japanese_winter", "slot_6"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_b",
    "name_jp": "ゆきだるまたち",
    "name_en": "Snowmen",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_6"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_c",
    "name_jp": "ゆきだるまたち",
    "name_en": "Snowmen",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_6"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_a",
    "name_jp": "こたつでみかん",
    "name_en": "Tangerines on Kotatsu",
    "tags": ["living", "07_trad_japanese_winter", "slot_7"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_b",
    "name_jp": "こたつでみかん",
    "name_en": "Kotatsu Oranges",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_7"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_c",
    "name_jp": "こたつでみかん",
    "name_en": "Kotatsu Oranges",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_7"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_a",
    "name_jp": "もちつきぺったん",
    "name_en": "Mochi Pounding",
    "tags": ["living", "07_trad_japanese_winter", "slot_8"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 18,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_b",
    "name_jp": "もちつきぺったん",
    "name_en": "Mochi Pounding",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_8"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 19,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_c",
    "name_jp": "もちつきぺったん",
    "name_en": "Mochi Pounding",
    "tags": ["no_gacha", "living", "07_trad_japanese_winter", "slot_8"],
    "room": "living",
    "theme": "07_trad_japanese_winter",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-20T15:00:00.000Z",
    "priority": 20,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_08_neon_party_1_wallpaper_a",
    "name_jp": "ネオン壁紙",
    "name_en": "Neon Wallpaper",
    "tags": ["living", "08_neon_party", "slot_1"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_1_wallpaper_b",
    "name_jp": "ネオン壁紙",
    "name_en": "Neon Wallpaper",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_1"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 1,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_1_wallpaper_c",
    "name_jp": "ネオン壁紙",
    "name_en": "Neon Wallpaper",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_1"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 1,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_2_floor_a",
    "name_jp": "ネオン床マット",
    "name_en": "Neon Floor Mat",
    "tags": ["living", "08_neon_party", "slot_2"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_08_neon_party_2_floor_b",
    "name_jp": "ネオン床マット",
    "name_en": "Neon Floor Mat",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_2"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 2,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_08_neon_party_2_floor_c",
    "name_jp": "ネオン床マット",
    "name_en": "Neon Floor Mat",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_2"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 2,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_a",
    "name_jp": "ハッピーネオン",
    "name_en": "Happy Neon",
    "tags": ["living", "08_neon_party", "slot_3"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_b",
    "name_jp": "ハッピーネオン",
    "name_en": "Happy Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_3"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 3,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_c",
    "name_jp": "ハッピーネオン",
    "name_en": "Happy Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_3"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 3,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_08_neon_party_4_painting_a",
    "name_jp": "いちごネオン",
    "name_en": "Strawberry Neon",
    "tags": ["living", "08_neon_party", "slot_4"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_4_painting_b",
    "name_jp": "いちごネオン",
    "name_en": "Strawberry Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_4"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 4,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_4_painting_c",
    "name_jp": "いちごネオン",
    "name_en": "Strawberry Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_4"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 4,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_08_neon_party_5_fireplace_a",
    "name_jp": "ぶるぶるネオン",
    "name_en": "Bubble Neon",
    "tags": ["living", "08_neon_party", "slot_5"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_08_neon_party_5_fireplace_b",
    "name_jp": "ぶるぶるネオン",
    "name_en": "Bubble Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_5"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 5,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_08_neon_party_5_fireplace_c",
    "name_jp": "ぶるぶるネオン",
    "name_en": "Bubble Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_5"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 5,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_08_neon_party_6_tree_a",
    "name_jp": "ドリンクネオン",
    "name_en": "Drink Neon",
    "tags": ["living", "08_neon_party", "slot_6"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_08_neon_party_6_tree_b",
    "name_jp": "ドリンクネオン",
    "name_en": "Drink Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_6"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 6,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_08_neon_party_6_tree_c",
    "name_jp": "ドリンクネオン",
    "name_en": "Drink Neon",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_6"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 6,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_08_neon_party_7_couch_a",
    "name_jp": "ネオンソファ",
    "name_en": "Neon Sofa",
    "tags": ["living", "08_neon_party", "slot_7"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_08_neon_party_7_couch_b",
    "name_jp": "ネオンソファ",
    "name_en": "Neon Sofa",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_7"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 7,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_08_neon_party_7_couch_c",
    "name_jp": "ネオンソファ",
    "name_en": "Neon Sofa",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_7"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 7,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_08_neon_party_8_sidetable_a",
    "name_jp": "ネオンサイドテーブル",
    "name_en": "Neon Side Table",
    "tags": ["living", "08_neon_party", "slot_8"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 21,
    "image": "01_living_room/08_neon_party/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_08_neon_party_8_sidetable_b",
    "name_jp": "ネオンサイドテーブル",
    "name_en": "Neon Side Table",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_8"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 8,
    "max_tier": 3,
    "color": "b",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 22,
    "image": "01_living_room/08_neon_party/02_color_B/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_08_neon_party_8_sidetable_c",
    "name_jp": "ネオンサイドテーブル",
    "name_en": "Neon Side Table",
    "tags": ["no_gacha", "living", "08_neon_party", "slot_8"],
    "room": "living",
    "theme": "08_neon_party",
    "slot": 8,
    "max_tier": 3,
    "color": "c",
    "release_date": "2022-12-27T15:00:00.000Z",
    "priority": 23,
    "image": "01_living_room/08_neon_party/03_color_C/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_09_valentine_day_1_wallpaper_a",
    "name_jp": "バレンタイン壁紙",
    "name_en": "Valentine Wallpaper",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_1"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_09_valentine_day_2_floor_a",
    "name_jp": "バレンタイン床マット",
    "name_en": "Valentine Rug",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_2"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_09_valentine_day_3_above_fireplace_a",
    "name_jp": "バレンタインオブジェ",
    "name_en": "Valentine Decor",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_3"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_09_valentine_day_4_painting_a",
    "name_jp": "バレンタイン壁掛け",
    "name_en": "Valentine Wall",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_4"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_09_valentine_day_5_fireplace_a",
    "name_jp": "バレンタインカップ",
    "name_en": "Valentine Cup",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_5"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_09_valentine_day_6_tree_a",
    "name_jp": "バレンタインケーキ",
    "name_en": "Valentine Cake",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_6"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_09_valentine_day_7_couch_a",
    "name_jp": "バレンタインソファ",
    "name_en": "Valentine Sofa",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_7"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_09_valentine_day_8_sidetable_a",
    "name_jp": "バレンタインテーブル",
    "name_en": "Valentine Table",
    "tags": ["event_gacha_only", "living", "09_valentine_day", "slot_8"],
    "room": "living",
    "theme": "09_valentine_day",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-06T15:00:00.000Z",
    "priority": 24,
    "image": "01_living_room/09_valentine_day/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_10_angel_1_wallpaper_a",
    "name_jp": "光の壁紙",
    "name_en": "Light Wallpaper",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_1"],
    "room": "living",
    "theme": "10_angel",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_10_angel_2_floor_a",
    "name_jp": "光の床マット",
    "name_en": "Light Rug",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_2"],
    "room": "living",
    "theme": "10_angel",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_10_angel_3_above_fireplace_a",
    "name_jp": "天使ちゃん",
    "name_en": "Angel Decor",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_3"],
    "room": "living",
    "theme": "10_angel",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_10_angel_4_painting_a",
    "name_jp": "天使の絵画",
    "name_en": "Angel Painting",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_4"],
    "room": "living",
    "theme": "10_angel",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_10_angel_5_fireplace_a",
    "name_jp": "天使のすみか",
    "name_en": "Angel Sanctuary",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_5"],
    "room": "living",
    "theme": "10_angel",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_10_angel_6_tree_a",
    "name_jp": "ステキな柱",
    "name_en": "Lovely Pillar",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_6"],
    "room": "living",
    "theme": "10_angel",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_10_angel_7_couch_a",
    "name_jp": "天使のソファ",
    "name_en": "Angel Sofa",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_7"],
    "room": "living",
    "theme": "10_angel",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_10_angel_8_sidetable_a",
    "name_jp": "天界のりんご",
    "name_en": "Heavenly Apple",
    "tags": ["event_gacha_only", "living", "10_angel", "slot_8"],
    "room": "living",
    "theme": "10_angel",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 25,
    "image": "01_living_room/10_angel/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_11_devil_1_wallpaper_a",
    "name_jp": "闇の壁紙",
    "name_en": "Dark Wallpaper",
    "tags": ["no_gacha", "living", "11_devil", "slot_1"],
    "room": "living",
    "theme": "11_devil",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_11_devil_2_floor_a",
    "name_jp": "闇の床マット",
    "name_en": "Dark Floor Mat",
    "tags": ["no_gacha", "living", "11_devil", "slot_2"],
    "room": "living",
    "theme": "11_devil",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_11_devil_3_above_fireplace_a",
    "name_jp": "悪魔ちゃん",
    "name_en": "Demon Doll",
    "tags": ["no_gacha", "living", "11_devil", "slot_3"],
    "room": "living",
    "theme": "11_devil",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_11_devil_4_painting_a",
    "name_jp": "悪魔の絵画",
    "name_en": "Demon Painting",
    "tags": ["no_gacha", "living", "11_devil", "slot_4"],
    "room": "living",
    "theme": "11_devil",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_11_devil_5_fireplace_a",
    "name_jp": "悪魔のすみか",
    "name_en": "Demon Sanctuary",
    "tags": ["no_gacha", "living", "11_devil", "slot_5"],
    "room": "living",
    "theme": "11_devil",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_11_devil_6_tree_a",
    "name_jp": "邪悪な柱",
    "name_en": "Evil Pillar",
    "tags": ["no_gacha", "living", "11_devil", "slot_6"],
    "room": "living",
    "theme": "11_devil",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_11_devil_7_couch_a",
    "name_jp": "悪魔のソファ",
    "name_en": "Demon Sofa",
    "tags": ["no_gacha", "living", "11_devil", "slot_7"],
    "room": "living",
    "theme": "11_devil",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_11_devil_8_sidetable_a",
    "name_jp": "魔界のりんご",
    "name_en": "Devil Apple",
    "tags": ["no_gacha", "living", "11_devil", "slot_8"],
    "room": "living",
    "theme": "11_devil",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 26,
    "image": "01_living_room/11_devil/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_12_hinamatsuri_a1_1_wallpaper_a",
    "name_jp": "ひなまつり壁紙",
    "name_en": "Hinamatsuri Wall",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_1"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_12_hinamatsuri_a1_2_floor_a",
    "name_jp": "ひなまつり床マット",
    "name_en": "Hina Floor Mat",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_2"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_12_hinamatsuri_a1_3_above_fireplace_a",
    "name_jp": "親王",
    "name_en": "Prince",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_3"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_12_hinamatsuri_a1_4_painting_a",
    "name_jp": "梅の花",
    "name_en": "Plum Blossom",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_4"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_12_hinamatsuri_a1_5_fireplace_a",
    "name_jp": "三人官女",
    "name_en": "Three Dancers",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_5"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_12_hinamatsuri_a1_6_tree_a",
    "name_jp": "ぼんぼり",
    "name_en": "Bonbori",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_6"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_12_hinamatsuri_a1_7_couch_a",
    "name_jp": "ひなまつりソファ",
    "name_en": "Hinamatsuri Sofa",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_7"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_12_hinamatsuri_a1_8_sidetable_a",
    "name_jp": "ひしもち",
    "name_en": "Dumplings",
    "tags": ["event_gacha_only", "living", "12_hinamatsuri_a1", "slot_8"],
    "room": "living",
    "theme": "12_hinamatsuri_a1",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 27,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_13_hinamatsuri_a2_1_wallpaper_a",
    "name_jp": "夜のひなまつり壁紙",
    "name_en": "Night Hinamatsuri Wallpaper",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_1"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_13_hinamatsuri_a2_2_floor_a",
    "name_jp": "夜のひなまつり床マット",
    "name_en": "Night Hinamatsuri Mat",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_2"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_13_hinamatsuri_a2_3_above_fireplace_a",
    "name_jp": "夜の親王",
    "name_en": "Night Prince",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_3"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_13_hinamatsuri_a2_4_painting_a",
    "name_jp": "ひなまつりの精",
    "name_en": "Hinamatsuri Spirit",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_4"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_13_hinamatsuri_a2_5_fireplace_a",
    "name_jp": "おはやし部隊",
    "name_en": "Ohayashi Squad",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_5"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_13_hinamatsuri_a2_6_tree_a",
    "name_jp": "夜のぼんぼり",
    "name_en": "Night Bonfire",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_6"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_13_hinamatsuri_a2_7_couch_a",
    "name_jp": "夜のひなまつりソファ",
    "name_en": "Night Hinamatsuri Sofa",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_7"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_13_hinamatsuri_a2_8_sidetable_a",
    "name_jp": "ひなあられ",
    "name_en": "Hina Arare",
    "tags": ["event_gacha_only", "living", "13_hinamatsuri_a2", "slot_8"],
    "room": "living",
    "theme": "13_hinamatsuri_a2",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-02-21T15:00:00.000Z",
    "priority": 28,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_14_whiteday_1_wallpaper_a",
    "name_jp": "ホワイトデー壁紙",
    "name_en": "White Day Wallpaper",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_1"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_14_whiteday_2_floor_a",
    "name_jp": "ホワイトデー床マット",
    "name_en": "Floor Mat",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_2"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_14_whiteday_3_above_fireplace_a",
    "name_jp": "ホワイトデーオブジェ",
    "name_en": "White Decor",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_3"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_14_whiteday_4_painting_a",
    "name_jp": "ホワイトデー壁掛け",
    "name_en": "Wall Decor",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_4"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_14_whiteday_5_fireplace_a",
    "name_jp": "ホワイトデーカップ",
    "name_en": "White Cup",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_5"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_14_whiteday_6_tree_a",
    "name_jp": "ホワイトデータワー",
    "name_en": "White Tower",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_6"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_14_whiteday_7_couch_a",
    "name_jp": "ホワイトデーソファ",
    "name_en": "White Sofa",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_7"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_14_whiteday_8_sidetable_a",
    "name_jp": "ホワイトデーテーブル",
    "name_en": "White Table",
    "tags": ["event_gacha_only", "living", "14_whiteday", "slot_8"],
    "room": "living",
    "theme": "14_whiteday",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-03-07T15:00:00.000Z",
    "priority": 29,
    "image": "01_living_room/14_whiteday/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "toilet_01_default_theme_3_empty_na",
    "name_jp": "かたづけ",
    "name_en": "Organizer",
    "tags": ["no_gacha", "toilet", "01_default_theme", "slot_3"],
    "room": "toilet",
    "theme": "01_default_theme",
    "slot": 3,
    "max_tier": 2,
    "color": "na",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "toilet_01_default_theme_5_empty_na",
    "name_jp": "かたづけ",
    "name_en": "Organizer",
    "tags": ["no_gacha", "toilet", "01_default_theme", "slot_5"],
    "room": "toilet",
    "theme": "01_default_theme",
    "slot": 5,
    "max_tier": 2,
    "color": "na",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 0,
    "currency": "gems",
    "price": 0
  },
  {
    "id": "toilet_02_deep_ocean_1_wallpaper_a",
    "name_jp": "海中壁紙",
    "name_en": "Undersea Wallpaper",
    "tags": ["toilet", "02_deep_ocean", "slot_1"],
    "room": "toilet",
    "theme": "02_deep_ocean",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 1,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_02_deep_ocean_2_floor_a",
    "name_jp": "海底床マット",
    "name_en": "Seabed Floor Mat",
    "tags": ["toilet", "02_deep_ocean", "slot_2"],
    "room": "toilet",
    "theme": "02_deep_ocean",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 1,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "toilet_02_deep_ocean_3_arch_a",
    "name_jp": "魚と貝のアーチ",
    "name_en": "Fish & Shell Arch",
    "tags": ["toilet", "02_deep_ocean", "slot_3"],
    "room": "toilet",
    "theme": "02_deep_ocean",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 1,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_arch.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "toilet_02_deep_ocean_4_toilet_a",
    "name_jp": "貝がらトイレ",
    "name_en": "Shell Toilet",
    "tags": ["toilet", "02_deep_ocean", "slot_4"],
    "room": "toilet",
    "theme": "02_deep_ocean",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 1,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/04_toilet.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_02_deep_ocean_5_toilet_ornament_a",
    "name_jp": "海底オブジェ",
    "name_en": "Seabed Ornament",
    "tags": ["toilet", "02_deep_ocean", "slot_5"],
    "room": "toilet",
    "theme": "02_deep_ocean",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 1,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/05_toilet_ornament.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "toilet_03_fresh_forrest_1_wallpaper_a",
    "name_jp": "森の壁紙",
    "name_en": "Forest Wallpaper",
    "tags": ["toilet", "03_fresh_forrest", "slot_1"],
    "room": "toilet",
    "theme": "03_fresh_forrest",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 2,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_03_fresh_forrest_2_floor_a",
    "name_jp": "森の床マット",
    "name_en": "Forest Floor Mat",
    "tags": ["toilet", "03_fresh_forrest", "slot_2"],
    "room": "toilet",
    "theme": "03_fresh_forrest",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 2,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "toilet_03_fresh_forrest_3_arch_a",
    "name_jp": "おはなのアーチ",
    "name_en": "Flower Arch",
    "tags": ["toilet", "03_fresh_forrest", "slot_3"],
    "room": "toilet",
    "theme": "03_fresh_forrest",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 2,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_arch.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "toilet_03_fresh_forrest_4_toilet_a",
    "name_jp": "黄色いおはなのトイレ",
    "name_en": "Yellow Flower Toilet",
    "tags": ["toilet", "03_fresh_forrest", "slot_4"],
    "room": "toilet",
    "theme": "03_fresh_forrest",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 2,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/04_toilet.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_03_fresh_forrest_5_toilet_ornament_a",
    "name_jp": "トイレの守り人",
    "name_en": "Toilet Guardian",
    "tags": ["toilet", "03_fresh_forrest", "slot_5"],
    "room": "toilet",
    "theme": "03_fresh_forrest",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 2,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/05_toilet_ornament.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "toilet_04_valentine_day_1_wallpaper_a",
    "name_jp": "バレンタイン壁紙",
    "name_en": "Valentine Wallpaper",
    "tags": ["no_gacha", "toilet", "04_valentine_day", "slot_1"],
    "room": "toilet",
    "theme": "04_valentine_day",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 3,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_04_valentine_day_2_floor_a",
    "name_jp": "バレンタイン床マット",
    "name_en": "Valentine Rug",
    "tags": ["no_gacha", "toilet", "04_valentine_day", "slot_2"],
    "room": "toilet",
    "theme": "04_valentine_day",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 3,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "toilet_04_valentine_day_3_arch_a",
    "name_jp": "バレンタインアーチ",
    "name_en": "Valentine Arch",
    "tags": ["no_gacha", "toilet", "04_valentine_day", "slot_3"],
    "room": "toilet",
    "theme": "04_valentine_day",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 3,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_arch.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "toilet_04_valentine_day_4_toilet_a",
    "name_jp": "バレンタイントイレ",
    "name_en": "Valentine Decor",
    "tags": ["no_gacha", "toilet", "04_valentine_day", "slot_4"],
    "room": "toilet",
    "theme": "04_valentine_day",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 3,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_toilet.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "toilet_04_valentine_day_5_toilet_ornament_a",
    "name_jp": "バレンタインおきもの",
    "name_en": "Valentine Ornament",
    "tags": ["no_gacha", "toilet", "04_valentine_day", "slot_5"],
    "room": "toilet",
    "theme": "04_valentine_day",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-01-18T15:00:00.000Z",
    "priority": 3,
    "image": "04_toilet_room/04_valentine_day/01_color_A/05_toilet_ornament.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_15_rainy_frogs_1_wallpaper_a",
    "name_jp": "雨降り壁紙",
    "name_en": "Rainy Wallpaper",
    "tags": ["living", "15_rainy_frogs", "slot_1"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_15_rainy_frogs_2_floor_a",
    "name_jp": "みずたまり床マット",
    "name_en": "Puddle Rug",
    "tags": ["living", "15_rainy_frogs", "slot_2"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_15_rainy_frogs_3_above_fireplace_a",
    "name_jp": "かえるズ",
    "name_en": "Frog Figurine",
    "tags": ["living", "15_rainy_frogs", "slot_3"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_15_rainy_frogs_4_painting_a",
    "name_jp": "ケロケロボード",
    "name_en": "Croak Board",
    "tags": ["living", "15_rainy_frogs", "slot_4"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_15_rainy_frogs_5_fireplace_a",
    "name_jp": "雨降りカエル",
    "name_en": "Rainy Frog",
    "tags": ["living", "15_rainy_frogs", "slot_5"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_15_rainy_frogs_6_tree_a",
    "name_jp": "あじさいタワー",
    "name_en": "Hydrangea Tower",
    "tags": ["living", "15_rainy_frogs", "slot_6"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_15_rainy_frogs_7_couch_a",
    "name_jp": "おひさまソファ",
    "name_en": "Sunshine Sofa",
    "tags": ["living", "15_rainy_frogs", "slot_7"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_15_rainy_frogs_8_sidetable_a",
    "name_jp": "ぴちぴち長靴",
    "name_en": "Fresh Boots",
    "tags": ["living", "15_rainy_frogs", "slot_8"],
    "room": "living",
    "theme": "15_rainy_frogs",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 30,
    "image": "01_living_room/15_rainy_frogs/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_16_milky_cow_1_wallpaper_a",
    "name_jp": "モーモー壁紙",
    "name_en": "Moo Wallpaper",
    "tags": ["living", "16_milky_cow", "slot_1"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_16_milky_cow_2_floor_a",
    "name_jp": "ぴよぴよ床マット",
    "name_en": "Chirp Floor Mat",
    "tags": ["living", "16_milky_cow", "slot_2"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_16_milky_cow_3_above_fireplace_a",
    "name_jp": "ミニ牧場",
    "name_en": "Mini Pasture",
    "tags": ["living", "16_milky_cow", "slot_3"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_16_milky_cow_4_painting_a",
    "name_jp": "ミルキーペイント",
    "name_en": "Milky Paint",
    "tags": ["living", "16_milky_cow", "slot_4"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_16_milky_cow_5_fireplace_a",
    "name_jp": "モーモーカップ",
    "name_en": "Moo Cup",
    "tags": ["living", "16_milky_cow", "slot_5"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_16_milky_cow_6_tree_a",
    "name_jp": "モーモーバルーン",
    "name_en": "Moo Balloon",
    "tags": ["living", "16_milky_cow", "slot_6"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_16_milky_cow_7_couch_a",
    "name_jp": "モーモーソファ",
    "name_en": "Moo Sofa",
    "tags": ["living", "16_milky_cow", "slot_7"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_16_milky_cow_8_sidetable_a",
    "name_jp": "モーモーラック",
    "name_en": "Moo Rack",
    "tags": ["living", "16_milky_cow", "slot_8"],
    "room": "living",
    "theme": "16_milky_cow",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-05-07T15:00:00.000Z",
    "priority": 31,
    "image": "01_living_room/16_milky_cow/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_17_halloween_1_wallpaper_a",
    "name_jp": "ハロウィン壁紙",
    "name_en": "Halloween Wallpaper",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_1"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_17_halloween_2_floor_a",
    "name_jp": "ハロウィン床マット",
    "name_en": "Halloween Rug",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_2"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_17_halloween_3_above_fireplace_a",
    "name_jp": "ハロウィンかぼちゃ",
    "name_en": "Halloween Pumpkin",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_3"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_17_halloween_4_painting_a",
    "name_jp": "ハロウィン壁掛け",
    "name_en": "Halloween Wall Art",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_4"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_17_halloween_5_fireplace_a",
    "name_jp": "ハロウィンカップ",
    "name_en": "Halloween Cup",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_5"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_17_halloween_6_tree_a",
    "name_jp": "ハロウィンツリー",
    "name_en": "Halloween Tree",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_6"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_17_halloween_7_couch_a",
    "name_jp": "ハロウィンソファ",
    "name_en": "Halloween Sofa",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_7"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_17_halloween_8_sidetable_a",
    "name_jp": "ハロウィンシチュー",
    "name_en": "Halloween Stew",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "17_halloween",
      "slot_8"
    ],
    "room": "living",
    "theme": "17_halloween",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 32,
    "image": "01_living_room/17_halloween/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_18_candy_house_1_wallpaper_a",
    "name_jp": "お菓子の壁紙",
    "name_en": "Candy Wallpaper",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_1"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 1,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_18_candy_house_2_floor_a",
    "name_jp": "お菓子の床マット",
    "name_en": "Candy Rug",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_2"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 2,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_18_candy_house_3_above_fireplace_a",
    "name_jp": "プリンオブジェ",
    "name_en": "Pudding Object",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_3"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 3,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 200
  },
  {
    "id": "living_18_candy_house_4_painting_a",
    "name_jp": "お菓子の壁掛け",
    "name_en": "Sweets Wall Art",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_4"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 4,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 150
  },
  {
    "id": "living_18_candy_house_5_fireplace_a",
    "name_jp": "お菓子のカップ",
    "name_en": "Sweets Cup",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_5"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 5,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 500
  },
  {
    "id": "living_18_candy_house_6_tree_a",
    "name_jp": "パフェツリー",
    "name_en": "Parfait Tree",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_6"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 6,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 300
  },
  {
    "id": "living_18_candy_house_7_couch_a",
    "name_jp": "マカロンソファ",
    "name_en": "Macaron Sofa",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_7"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 7,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 400
  },
  {
    "id": "living_18_candy_house_8_sidetable_a",
    "name_jp": "ケーキサイドテーブル",
    "name_en": "Cake Side Table",
    "tags": [
      "no_gacha",
      "event_gacha_only",
      "living",
      "18_candy_house",
      "slot_8"
    ],
    "room": "living",
    "theme": "18_candy_house",
    "slot": 8,
    "max_tier": 4,
    "color": "a",
    "release_date": "2023-09-20T15:00:00.000Z",
    "priority": 33,
    "image": "01_living_room/18_candy_house/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 50
  },
  {
    "id": "living_19_circus_1_wallpaper_a",
    "name_jp": "サーカス壁紙",
    "name_en": "Circus Wallpaper",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_1"],
    "room": "living",
    "theme": "19_circus",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_19_circus_2_floor_a",
    "name_jp": "サーカス床マット",
    "name_en": "Circus Floor Mat",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_2"],
    "room": "living",
    "theme": "19_circus",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_19_circus_3_above_fireplace_a",
    "name_jp": "サーカスのオブジェ",
    "name_en": "Circus Object",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_3"],
    "room": "living",
    "theme": "19_circus",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_19_circus_4_painting_a",
    "name_jp": "壁掛けダーツ",
    "name_en": "Dart Wall Decor",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_4"],
    "room": "living",
    "theme": "19_circus",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_19_circus_5_fireplace_a",
    "name_jp": "サーカスのカップ",
    "name_en": "Circus Cup",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_5"],
    "room": "living",
    "theme": "19_circus",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_19_circus_6_tree_a",
    "name_jp": "ポップコーン屋台",
    "name_en": "Popcorn Stand",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_6"],
    "room": "living",
    "theme": "19_circus",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_19_circus_7_couch_a",
    "name_jp": "サーカスソファー",
    "name_en": "Circus Sofa",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_7"],
    "room": "living",
    "theme": "19_circus",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_19_circus_8_sidetable_a",
    "name_jp": "サーカスの台",
    "name_en": "Circus Stand",
    "tags": ["event_gacha_only", "living", "19_circus", "slot_8"],
    "room": "living",
    "theme": "19_circus",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-04-26T15:00:00.000Z",
    "priority": 34,
    "image": "01_living_room/19_circus/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_20_space_1_wallpaper_a",
    "name_jp": "宇宙の壁紙",
    "name_en": "Space Wallpaper",
    "tags": ["event_gacha_only", "living", "20_space", "slot_1"],
    "room": "living",
    "theme": "20_space",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_20_space_2_floor_a",
    "name_jp": "スペース床マット",
    "name_en": "Space Floor Mat",
    "tags": ["event_gacha_only", "living", "20_space", "slot_2"],
    "room": "living",
    "theme": "20_space",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_20_space_3_above_fireplace_a",
    "name_jp": "宇宙人のオブジェ",
    "name_en": "Alien Decor",
    "tags": ["event_gacha_only", "living", "20_space", "slot_3"],
    "room": "living",
    "theme": "20_space",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_20_space_4_painting_a",
    "name_jp": "惑星の壁掛け",
    "name_en": "Planet Wall Art",
    "tags": ["event_gacha_only", "living", "20_space", "slot_4"],
    "room": "living",
    "theme": "20_space",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_20_space_5_fireplace_a",
    "name_jp": "宇宙船のカップ",
    "name_en": "Spaceship Cup",
    "tags": ["event_gacha_only", "living", "20_space", "slot_5"],
    "room": "living",
    "theme": "20_space",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_20_space_6_tree_a",
    "name_jp": "ロケット",
    "name_en": "Rocket",
    "tags": ["event_gacha_only", "living", "20_space", "slot_6"],
    "room": "living",
    "theme": "20_space",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_20_space_7_couch_a",
    "name_jp": "宇宙船ソファー",
    "name_en": "Spaceship Sofa",
    "tags": ["event_gacha_only", "living", "20_space", "slot_7"],
    "room": "living",
    "theme": "20_space",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_20_space_8_sidetable_a",
    "name_jp": "ソーラーパネルの台",
    "name_en": "Solar Panel Stand",
    "tags": ["event_gacha_only", "living", "20_space", "slot_8"],
    "room": "living",
    "theme": "20_space",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-06-30T15:00:00.000Z",
    "priority": 35,
    "image": "01_living_room/20_space/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_21_egyptian_1_wallpaper_a",
    "name_jp": "エジプト壁紙",
    "name_en": "Egypt Wallpaper",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_1"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_21_egyptian_2_floor_a",
    "name_jp": "エジプト床マット",
    "name_en": "Egypt Floor Mat",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_2"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_21_egyptian_3_above_fireplace_a",
    "name_jp": "エジプトのオブジェ",
    "name_en": "Egypt Ornament",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_3"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_21_egyptian_4_painting_a",
    "name_jp": "エジプトの壁画",
    "name_en": "Egypt Wall Art",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_4"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_21_egyptian_5_fireplace_a",
    "name_jp": "エジプトカップ",
    "name_en": "Egypt Cup",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_5"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_21_egyptian_6_tree_a",
    "name_jp": "エジプトの柱",
    "name_en": "Egypt Column",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_6"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_21_egyptian_7_couch_a",
    "name_jp": "エジプトソファー",
    "name_en": "Egypt Sofa",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_7"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_21_egyptian_8_sidetable_a",
    "name_jp": "エジプトの台",
    "name_en": "Egypt Stand",
    "tags": ["event_gacha_only", "living", "21_egyptian", "slot_8"],
    "room": "living",
    "theme": "21_egyptian",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-07-25T15:00:00.000Z",
    "priority": 36,
    "image": "01_living_room/21_egyptian/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_22_fruitsandcream_1_wallpaper_a",
    "name_jp": "クリームの壁紙",
    "name_en": "Cream Wallpaper",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_1"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_22_fruitsandcream_2_floor_a",
    "name_jp": "フルーツ床マット",
    "name_en": "Fruit Floor Mat",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_2"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_22_fruitsandcream_3_above_fireplace_a",
    "name_jp": "クリームのオブジェ",
    "name_en": "Cream Decoration",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_3"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_22_fruitsandcream_4_painting_a",
    "name_jp": "壁掛けフルーツ",
    "name_en": "Fruit Wall Decor",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_4"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_22_fruitsandcream_5_fireplace_a",
    "name_jp": "イチゴのカップ",
    "name_en": "Strawberry Cup",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_5"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_22_fruitsandcream_6_tree_a",
    "name_jp": "大福ソファー",
    "name_en": "Mochi Sofa",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_6"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_22_fruitsandcream_7_couch_a",
    "name_jp": "フルーツの柱",
    "name_en": "Fruit Pillar",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_7"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_22_fruitsandcream_8_sidetable_a",
    "name_jp": "フルーツの台",
    "name_en": "Fruit Stand",
    "tags": ["event_gacha_only", "living", "22_fruitsandcream", "slot_8"],
    "room": "living",
    "theme": "22_fruitsandcream",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-08-31T15:00:00.000Z",
    "priority": 37,
    "image": "01_living_room/22_fruitsandcream/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_23_halloween2024_1_wallpaper_a",
    "name_jp": "ハロウィン2024壁紙",
    "name_en": "Halloween 2024 Wallpaper",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_1"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_23_halloween2024_2_floor_a",
    "name_jp": "ハロウィン2024床マット",
    "name_en": "Halloween 2024 Floor Mat",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_2"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_23_halloween2024_3_above_fireplace_a",
    "name_jp": "ハロウィン2024帽子",
    "name_en": "Halloween 2024 Hat",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_3"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_23_halloween2024_4_painting_a",
    "name_jp": "ハロウィン2024壁掛け",
    "name_en": "Halloween 2024 Wall Decor",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_4"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_23_halloween2024_5_fireplace_a",
    "name_jp": "ハロウィン2024カップ",
    "name_en": "Halloween 2024 Cup",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_5"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_23_halloween2024_6_tree_a",
    "name_jp": "ハロウィン2024ツリー",
    "name_en": "Halloween 2024 Tree",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_6"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_23_halloween2024_7_couch_a",
    "name_jp": "ハロウィン2024ソファ",
    "name_en": "Halloween 2024 Sofa",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_7"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_23_halloween2024_8_sidetable_a",
    "name_jp": "ハロウィン2024シチュー",
    "name_en": "Halloween 2024 Stew",
    "tags": ["event_gacha_only", "living", "23_halloween2024", "slot_8"],
    "room": "living",
    "theme": "23_halloween2024",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-09-29T15:00:00.000Z",
    "priority": 38,
    "image": "01_living_room/23_halloween2024/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_24_moonviewing_1_wallpaper_a",
    "name_jp": "お月見壁紙",
    "name_en": "Moon Viewing Wallpaper",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_1"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_24_moonviewing_2_floor_a",
    "name_jp": "お月見床マット",
    "name_en": "Moon Viewing Floor Mat",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_2"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_24_moonviewing_3_above_fireplace_a",
    "name_jp": "お屋敷かざり",
    "name_en": "Mansion Decoration",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_3"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_24_moonviewing_4_painting_a",
    "name_jp": "お月見壁掛け",
    "name_en": "Moon Viewing Wall Hanging",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_4"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_24_moonviewing_5_fireplace_a",
    "name_jp": "お屋敷カップ",
    "name_en": "Mansion Cup",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_5"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_24_moonviewing_6_tree_a",
    "name_jp": "紅葉ツリー",
    "name_en": "Maple Tree",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_6"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_24_moonviewing_7_couch_a",
    "name_jp": "お月見ソファ",
    "name_en": "Moon Viewing Sofa",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_7"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_24_moonviewing_8_sidetable_a",
    "name_jp": "お月見団子",
    "name_en": "Moon Viewing Dumplings",
    "tags": ["event_gacha_only", "living", "24_moonviewing", "slot_8"],
    "room": "living",
    "theme": "24_moonviewing",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-10-30T15:00:00.000Z",
    "priority": 39,
    "image": "01_living_room/24_moonviewing/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_25_cute_xmas_1_wallpaper_a",
    "name_jp": "きゃわXmas壁紙",
    "name_en": "Cute Xmas Wallpaper",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_1"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_25_cute_xmas_2_floor_a",
    "name_jp": "きゃわXmasカーペット",
    "name_en": "Cute Xmas Carpet",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_2"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_25_cute_xmas_3_above_fireplace_a",
    "name_jp": "きゃわXmasのソリ",
    "name_en": "Cute Xmas Sleigh",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_3"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_25_cute_xmas_4_painting_a",
    "name_jp": "きゃわXmasリース",
    "name_en": "Cute Xmas Wreath",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_4"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_25_cute_xmas_5_fireplace_a",
    "name_jp": "きゃわXmasマグカップ",
    "name_en": "Cute Xmas Mug",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_5"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_25_cute_xmas_6_tree_a",
    "name_jp": "きゃわXmasツリー",
    "name_en": "Cute Xmas Tree",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_6"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_25_cute_xmas_7_couch_a",
    "name_jp": "きゃわXmasソファー",
    "name_en": "Cute Xmas Sofa",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_7"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_25_cute_xmas_8_sidetable_a",
    "name_jp": "きゃわXmasテーブル",
    "name_en": "Cute Xmas Table",
    "tags": ["event_gacha_only", "living", "25_cute_xmas", "slot_8"],
    "room": "living",
    "theme": "25_cute_xmas",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-11-29T15:00:00.000Z",
    "priority": 40,
    "image": "01_living_room/25_cute_xmas/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_26_new_year_2025_1_wallpaper_a",
    "name_jp": "あけおめ25壁紙",
    "name_en": "NewYear25 Wallpaper",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_1"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_26_new_year_2025_2_floor_a",
    "name_jp": "あけおめ25カーペット",
    "name_en": "NewYear25 Carpet",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_2"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_26_new_year_2025_3_above_fireplace_a",
    "name_jp": "あけおめ25鏡餅",
    "name_en": "NewYear25 KagamiMochi",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_3"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_26_new_year_2025_4_painting_a",
    "name_jp": "あけおめ25初夢の絵",
    "name_en": "NewYear25 FirstDreamPainting",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_4"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_26_new_year_2025_5_fireplace_a",
    "name_jp": "あけおめ25新年カップ",
    "name_en": "NewYear25 NewYearCup",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_5"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_26_new_year_2025_6_tree_a",
    "name_jp": "あけおめ25正月飾り",
    "name_en": "NewYear25 Decoration",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_6"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_26_new_year_2025_7_couch_a",
    "name_jp": "あけおめ25こたつ",
    "name_en": "NewYear25 Kotatsu",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_7"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_26_new_year_2025_8_sidetable_a",
    "name_jp": "あけおめ25絵馬",
    "name_en": "NewYear25 Ema",
    "tags": ["event_gacha_only", "living", "26_new_year_2025", "slot_8"],
    "room": "living",
    "theme": "26_new_year_2025",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2024-12-30T15:00:00.000Z",
    "priority": 41,
    "image": "01_living_room/26_new_year_2025/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_27_setsubun_1_wallpaper_a",
    "name_jp": "節分壁紙",
    "name_en": "Setsubun Wallpaper",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_1"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_27_setsubun_2_floor_a",
    "name_jp": "節分カーペット",
    "name_en": "Setsubun Carpet",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_2"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_27_setsubun_3_above_fireplace_a",
    "name_jp": "節分の鬼の飾り",
    "name_en": "Setsubun Oni Ornament",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_3"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_27_setsubun_4_painting_a",
    "name_jp": "節分の飾り",
    "name_en": "Setsubun Decoration",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_4"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_27_setsubun_5_fireplace_a",
    "name_jp": "節分カップ",
    "name_en": "Setsubun Cup",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_5"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_27_setsubun_6_tree_a",
    "name_jp": "節分の旗",
    "name_en": "Setsubun Flag",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_6"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_27_setsubun_7_couch_a",
    "name_jp": "節分の豆",
    "name_en": "Setsubun Beans",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_7"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_27_setsubun_8_sidetable_a",
    "name_jp": "節分の鬼",
    "name_en": "Setsubun Oni",
    "tags": ["event_gacha_only", "living", "27_setsubun", "slot_8"],
    "room": "living",
    "theme": "27_setsubun",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 42,
    "image": "01_living_room/27_setsubun/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_28_cafe_1_wallpaper_a",
    "name_jp": "カフェの壁紙",
    "name_en": "Cafe wallpaper",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_1"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_28_cafe_2_floor_a",
    "name_jp": "カフェのカーペット",
    "name_en": "Cafe carpet",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_2"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_28_cafe_3_above_fireplace_a",
    "name_jp": "カフェの置物",
    "name_en": "Cafe ornament",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_3"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_28_cafe_4_painting_a",
    "name_jp": "カフェメニュー",
    "name_en": "Cafe menu",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_4"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_28_cafe_5_fireplace_a",
    "name_jp": "カフェのカップ",
    "name_en": "Cafe cup",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_5"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_28_cafe_6_tree_a",
    "name_jp": "カフェのスイーツ",
    "name_en": "Cafe sweets",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_6"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_28_cafe_7_couch_a",
    "name_jp": "カフェのソファー",
    "name_en": "Cafe sofa",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_7"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_28_cafe_8_sidetable_a",
    "name_jp": "ジャムのテーブル",
    "name_en": "Jam table",
    "tags": ["event_gacha_only", "living", "28_cafe", "slot_8"],
    "room": "living",
    "theme": "28_cafe",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-01-30T15:00:00.000Z",
    "priority": 43,
    "image": "01_living_room/28_cafe/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_29_hanami_1_wallpaper_a",
    "name_jp": "春の富士壁紙",
    "name_en": "Spring Fuji Wallpaper",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_1"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_29_hanami_2_floor_a",
    "name_jp": "お花見レジャーシート",
    "name_en": "Hanami Leisure Sheet",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_2"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_29_hanami_3_above_fireplace_a",
    "name_jp": "お花見の桜餅",
    "name_en": "Hanami Sakura Mochi",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_3"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_29_hanami_4_painting_a",
    "name_jp": "桜の絵馬",
    "name_en": "Sakura Ema",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_4"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_29_hanami_5_fireplace_a",
    "name_jp": "お花見カップ",
    "name_en": "Hanami Cup",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_5"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_29_hanami_6_tree_a",
    "name_jp": "お花見",
    "name_en": "Hanami",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_6"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_29_hanami_7_couch_a",
    "name_jp": "お花見の椅子",
    "name_en": "Hanami Chair",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_7"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_29_hanami_8_sidetable_a",
    "name_jp": "お花見の飾り",
    "name_en": "Hanami Decorations",
    "tags": ["event_gacha_only", "living", "29_hanami", "slot_8"],
    "room": "living",
    "theme": "29_hanami",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-03-30T15:00:00.000Z",
    "priority": 44,
    "image": "01_living_room/29_hanami/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_30_childrens_day2025_1_wallpaper_a",
    "name_jp": "こどもの日25壁紙",
    "name_en": "Children’s Day 25 Wallpaper",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_1"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_30_childrens_day2025_2_floor_a",
    "name_jp": "こどもの日25レジャーシート",
    "name_en": "Children’s Day 25 Leisure Sheet",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_2"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_30_childrens_day2025_3_above_fireplace_a",
    "name_jp": "こどもの日25兜飾り",
    "name_en": "Children’s Day 25 Kabuto Ornament",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_3"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_30_childrens_day2025_4_painting_a",
    "name_jp": "こどもの日25絵馬",
    "name_en": "Children’s Day 25 Ema",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_4"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_30_childrens_day2025_5_fireplace_a",
    "name_jp": "こどもの日25カップ",
    "name_en": "Children’s Day 25 Cup",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_5"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_30_childrens_day2025_6_tree_a",
    "name_jp": "こどもの日25こいのぼり",
    "name_en": "Children’s Day 25 Koinobori",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_6"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_30_childrens_day2025_7_couch_a",
    "name_jp": "こどもの日25ぬいぐるみ",
    "name_en": "Children’s Day 25 Stuffed Animals",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_7"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_30_childrens_day2025_8_sidetable_a",
    "name_jp": "こどもの日25柏餅",
    "name_en": "Children’s Day 25 Kashiwa Mochi",
    "tags": ["event_gacha_only", "living", "childrens_day2025", "slot_8"],
    "room": "living",
    "theme": "30_childrens_day2025",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-04-29T15:00:00.000Z",
    "priority": 45,
    "image": "01_living_room/30_childrens_day2025/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_31_mothers_day2025_1_wallpaper_a",
    "name_jp": "母の日の壁紙",
    "name_en": "Mother’s Day Wallpaper",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_1"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_31_mothers_day2025_2_floor_a",
    "name_jp": "母の日のカーペット",
    "name_en": "Mother’s Day Carpet",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_2"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_31_mothers_day2025_3_above_fireplace_a",
    "name_jp": "母の日のオブジェ",
    "name_en": "Mother’s Day Ornament",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_3"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_31_mothers_day2025_4_painting_a",
    "name_jp": "母の日の絵",
    "name_en": "Mother’s Day Painting",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_4"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_31_mothers_day2025_5_fireplace_a",
    "name_jp": "母の日のティーカップ",
    "name_en": "Mother’s Day Tea Cup",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_5"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_31_mothers_day2025_6_tree_a",
    "name_jp": "母の日のツリー",
    "name_en": "Mother’s Day Tree",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_6"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_31_mothers_day2025_7_couch_a",
    "name_jp": "母の日のカーネーション",
    "name_en": "Mother’s Day Flower",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_7"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_31_mothers_day2025_8_sidetable_a",
    "name_jp": "母の日のチョコレート",
    "name_en": "Mother’s Day Chocolate",
    "tags": ["event_gacha_only", "living", "31_mothers_day2025", "slot_8"],
    "room": "living",
    "theme": "31_mothers_day2025",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-08T15:00:00.000Z",
    "priority": 46,
    "image": "01_living_room/31_mothers_day2025/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_32_melon_season_1_wallpaper_a",
    "name_jp": "メロン・シーズン壁紙",
    "name_en": "Melon Season Wallpaper",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_1"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_32_melon_season_2_floor_a",
    "name_jp": "メロン・シーズンカーペット",
    "name_en": "Melon Season Carpet",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_2"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_32_melon_season_3_above_fireplace_a",
    "name_jp": "メロンのオブジェ",
    "name_en": "Melon Ornament",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_3"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_32_melon_season_4_painting_a",
    "name_jp": "メロンの絵",
    "name_en": "Melon Painting",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_4"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_32_melon_season_5_fireplace_a",
    "name_jp": "メロンの器",
    "name_en": "Melon Bowl",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_5"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_32_melon_season_6_tree_a",
    "name_jp": "メロンの木",
    "name_en": "Melon Tree",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_6"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_32_melon_season_7_couch_a",
    "name_jp": "メロンソファー",
    "name_en": "Melon Sofa",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_7"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_32_melon_season_8_sidetable_a",
    "name_jp": "メロンの台",
    "name_en": "Melon Side Table",
    "tags": ["event_gacha_only", "living", "32_melon_season", "slot_8"],
    "room": "living",
    "theme": "32_melon_season",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-05-30T15:00:00.000Z",
    "priority": 47,
    "image": "01_living_room/32_melon_season/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_33_tanabata_1_wallpaper_a",
    "name_jp": "七夕の壁紙",
    "name_en": "Tanabata Wallpaper",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_1"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_33_tanabata_2_floor_a",
    "name_jp": "七夕のレジャーシート",
    "name_en": "Tanabata Leisure Sheet",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_2"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_33_tanabata_3_above_fireplace_a",
    "name_jp": "七夕のぬいぐるみ",
    "name_en": "Tanabata Stuffed Dolls",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_3"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_33_tanabata_4_painting_a",
    "name_jp": "七夕の星飾り",
    "name_en": "Star Ornament for Tanabata",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_4"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_33_tanabata_5_fireplace_a",
    "name_jp": "七夕のカップ",
    "name_en": "Tanabata Cup",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_5"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_33_tanabata_6_tree_a",
    "name_jp": "七夕の笹飾り",
    "name_en": "Tanabata Bamboo Decoration",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_6"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_33_tanabata_7_couch_a",
    "name_jp": "七夕の椅子",
    "name_en": "Tanabata Chair",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_7"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_33_tanabata_8_sidetable_a",
    "name_jp": "七夕の牛",
    "name_en": "Tanabata Cow",
    "tags": ["event_gacha_only", "living", "33_tanabata", "slot_8"],
    "room": "living",
    "theme": "33_tanabata",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-06-29T15:00:00.000Z",
    "priority": 48,
    "image": "01_living_room/33_tanabata/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_34_kakigori_1_wallpaper_a",
    "name_jp": "富士山の壁紙",
    "name_en": "Mt. Fuji Wallpaper",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_1"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_34_kakigori_2_floor_a",
    "name_jp": "木目の床",
    "name_en": "Wooden Floor",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_2"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_34_kakigori_3_above_fireplace_a",
    "name_jp": "氷ののれん",
    "name_en": "Shaved Ice Noren",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_3"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_34_kakigori_4_painting_a",
    "name_jp": "かき氷のぬいぐるみ",
    "name_en": "Shaved Ice Bear Plush",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_4"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_34_kakigori_5_fireplace_a",
    "name_jp": "花火カップ",
    "name_en": "Fireworks Cup",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_5"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_34_kakigori_6_tree_a",
    "name_jp": "かき氷マシン",
    "name_en": "Shaved Ice Machine",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_6"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_34_kakigori_7_couch_a",
    "name_jp": "いちごのかき氷",
    "name_en": "Strawberry Shaved Ice",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_7"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_34_kakigori_8_sidetable_a",
    "name_jp": "マンゴーかき氷",
    "name_en": "Mango Shaved Ice",
    "tags": ["event_gacha_only", "living", "34_kakigori", "slot_8"],
    "room": "living",
    "theme": "34_kakigori",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 49,
    "image": "01_living_room/34_kakigori/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_35_moonviewing2025_1_wallpaper_a",
    "name_jp": "お月見のふすま",
    "name_en": "Moon Viewing Sliding Doors",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_1"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_35_moonviewing2025_2_floor_a",
    "name_jp": "お月見の床",
    "name_en": "Moon Viewing Floor",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_2"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_35_moonviewing2025_3_above_fireplace_a",
    "name_jp": "お月見掛け軸",
    "name_en": "Moon Viewing Hanging Scroll",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_3"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_35_moonviewing2025_4_painting_a",
    "name_jp": "うさぎと杵臼",
    "name_en": "Rabbit with Mortar and Pestle",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_4"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_35_moonviewing2025_5_fireplace_a",
    "name_jp": "お月見のカップ",
    "name_en": "Moon Viewing Cup",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_5"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_35_moonviewing2025_6_tree_a",
    "name_jp": "月見だんごオブジェ",
    "name_en": "Moon Dumpling Ornament",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_6"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_35_moonviewing2025_7_couch_a",
    "name_jp": "月見のお供物",
    "name_en": "Moon Viewing Offering",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_7"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_35_moonviewing2025_8_sidetable_a",
    "name_jp": "月見のおつまみ",
    "name_en": "Moon Viewing Snacks",
    "tags": ["event_gacha_only", "living", "35_moonviewing2025", "slot_8"],
    "room": "living",
    "theme": "35_moonviewing2025",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-07-30T15:00:00.000Z",
    "priority": 50,
    "image": "01_living_room/35_moonviewing2025/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_36_magicalbooks_1_wallpaper_a",
    "name_jp": "魔法の読書壁紙",
    "name_en": "Magical Reading Wallpaper",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_1"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_36_magicalbooks_2_floor_a",
    "name_jp": "魔法のきのこ床",
    "name_en": "Magical Mushroom Floor",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_2"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_36_magicalbooks_3_above_fireplace_a",
    "name_jp": "クリームの飾り",
    "name_en": "Cream Decoration",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_3"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_36_magicalbooks_4_painting_a",
    "name_jp": "秋の提灯飾り",
    "name_en": "Autumn Lantern Decoration",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_4"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_36_magicalbooks_5_fireplace_a",
    "name_jp": "魔法の本棚カップ",
    "name_en": "Magical Bookshelf Cup",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_5"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_36_magicalbooks_6_tree_a",
    "name_jp": "積読のツリー",
    "name_en": "Piled Books Tree",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_6"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_36_magicalbooks_7_couch_a",
    "name_jp": "読書のソファー",
    "name_en": "Reading Sofa",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_7"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_36_magicalbooks_8_sidetable_a",
    "name_jp": "読書用切り株テーブル",
    "name_en": "Tree Stump Reading Table",
    "tags": ["event_gacha_only", "living", "36_magicalbooks", "slot_8"],
    "room": "living",
    "theme": "36_magicalbooks",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-09-29T15:00:00.000Z",
    "priority": 51,
    "image": "01_living_room/36_magicalbooks/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_37_taste_autumn_1_wallpaper_a",
    "name_jp": "秋の山の壁紙",
    "name_en": "Autumn Mountain Wallpaper",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_1"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_37_taste_autumn_2_floor_a",
    "name_jp": "落ち葉の床",
    "name_en": "Fallen Leaves Floor",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_2"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_37_taste_autumn_3_above_fireplace_a",
    "name_jp": "いくらの飾り",
    "name_en": "Salmon Roe Ornament",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_3"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_37_taste_autumn_4_painting_a",
    "name_jp": "きのこの飾り",
    "name_en": "Mushroom Ornament",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_4"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_37_taste_autumn_5_fireplace_a",
    "name_jp": "海のカップ",
    "name_en": "Ocean Cup",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_5"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_37_taste_autumn_6_tree_a",
    "name_jp": "秋の味覚プレート",
    "name_en": "Autumn Delicacy Plate",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_6"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_37_taste_autumn_7_couch_a",
    "name_jp": "新米の袋",
    "name_en": "Fresh Rice Sack",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_7"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_37_taste_autumn_8_sidetable_a",
    "name_jp": "七輪とさんま",
    "name_en": "Charcoal Grill with Pacific Saury",
    "tags": ["event_gacha_only", "living", "37_taste_autumn", "slot_8"],
    "room": "living",
    "theme": "37_taste_autumn",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-10-30T15:00:00.000Z",
    "priority": 52,
    "image": "01_living_room/37_taste_autumn/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_38_winter_candle_1_wallpaper_a",
    "name_jp": "雪の森の壁紙",
    "name_en": "Snowy Forest Wallpaper",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_1"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_38_winter_candle_2_floor_a",
    "name_jp": "氷の岩マット",
    "name_en": "Ice Rock Mat",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_2"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_38_winter_candle_3_above_fireplace_a",
    "name_jp": "冬のキャンドル",
    "name_en": "Winter Candle",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_3"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_38_winter_candle_4_painting_a",
    "name_jp": "星型キャンドル",
    "name_en": "Star-Shaped Candle",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_4"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_38_winter_candle_5_fireplace_a",
    "name_jp": "冬のコタツカップ",
    "name_en": "Winter Kotatsu Cup",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_5"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_38_winter_candle_6_tree_a",
    "name_jp": "冬のツリーキャンドル",
    "name_en": "Winter Tree Candle",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_6"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_38_winter_candle_7_couch_a",
    "name_jp": "雪だるまのオブジェ",
    "name_en": "Snowman Ornament",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_7"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_38_winter_candle_8_sidetable_a",
    "name_jp": "雪うさぎのオブジェ",
    "name_en": "Snow Rabbit Ornament",
    "tags": ["event_gacha_only", "living", "38_winter_candle", "slot_8"],
    "room": "living",
    "theme": "38_winter_candle",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-11-29T15:00:00.000Z",
    "priority": 53,
    "image": "01_living_room/38_winter_candle/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_39_ice_queens_castle_1_wallpaper_a",
    "name_jp": "氷の森の壁紙",
    "name_en": "Frozen Forest Wallpaper",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_1"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_39_ice_queens_castle_2_floor_a",
    "name_jp": "氷の床",
    "name_en": "Icy Floor",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_2"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_39_ice_queens_castle_3_above_fireplace_a",
    "name_jp": "星降る氷のキャンドル",
    "name_en": "Starfrost Candle",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_3"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_39_ice_queens_castle_4_painting_a",
    "name_jp": "氷灯りのキャンドル",
    "name_en": "Frostlight Candle",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_4"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_39_ice_queens_castle_5_fireplace_a",
    "name_jp": "氷城のティーカップ",
    "name_en": "Ice Castle Tea Cup",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_5"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_39_ice_queens_castle_6_tree_a",
    "name_jp": "氷晶のツリー",
    "name_en": "Crystal Ice Tree",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_6"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_39_ice_queens_castle_7_couch_a",
    "name_jp": "雪だるまの番人",
    "name_en": "Snowman Guardian",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_7"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_39_ice_queens_castle_8_sidetable_a",
    "name_jp": "氷花のベッド",
    "name_en": "Frost Blossom Bed",
    "tags": ["event_gacha_only", "living", "39_ice_queens_castle", "slot_8"],
    "room": "living",
    "theme": "39_ice_queens_castle",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2025-12-30T15:00:00.000Z",
    "priority": 54,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_40_artisan_chocolatier_1_wallpaper_a",
    "name_jp": "チョコレート専門店の壁紙",
    "name_en": "Artisan Chocolatier Wallpaper",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_1"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_40_artisan_chocolatier_2_floor_a",
    "name_jp": "チョコレート専門店の床",
    "name_en": "Artisan Chocolatier Floor",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_2"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_40_artisan_chocolatier_3_above_fireplace_a",
    "name_jp": "チョコフォンデュ",
    "name_en": "Chocolate fondue",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_3"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_40_artisan_chocolatier_4_painting_a",
    "name_jp": "ハートチョコのアート",
    "name_en": "Heart Chocolate Art",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_4"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_40_artisan_chocolatier_5_fireplace_a",
    "name_jp": "チョコレートカップ",
    "name_en": "Chocolate Mug",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_5"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_40_artisan_chocolatier_6_tree_a",
    "name_jp": "チョコレートツリー",
    "name_en": "Chocolate Tree",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_6"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_40_artisan_chocolatier_7_couch_a",
    "name_jp": "チョコマカロンのソファ",
    "name_en": "Chocolate Macaron Sofa",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_7"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_40_artisan_chocolatier_8_sidetable_a",
    "name_jp": "ギフトチョコのテーブル",
    "name_en": "Gift Chocolate Table",
    "tags": ["event_gacha_only", "living", "40_artisan_chocolatier", "slot_8"],
    "room": "living",
    "theme": "40_artisan_chocolatier",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-01-30T15:00:00.000Z",
    "priority": 55,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_41_valentine_day_1_wallpaper_a",
    "name_jp": "バレンタインの壁紙",
    "name_en": "Valentine's Day Wallpaper",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_1"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_41_valentine_day_2_floor_a",
    "name_jp": "バレンタインの床",
    "name_en": "Valentine's Day Floor",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_2"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_41_valentine_day_3_above_fireplace_a",
    "name_jp": "バレンタインのハートラグ",
    "name_en": "Valentine Heart Rug",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_3"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_41_valentine_day_4_painting_a",
    "name_jp": "ハートフレームアート",
    "name_en": "Heart Frame Art",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_4"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_41_valentine_day_5_fireplace_a",
    "name_jp": "バレンタインのカップ",
    "name_en": "Valentine's Day Cup",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_5"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_41_valentine_day_6_tree_a",
    "name_jp": "バレンタインローズツリー",
    "name_en": "Valentine Rose Tree",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_6"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_41_valentine_day_7_couch_a",
    "name_jp": "バレンタインうさぎぬいぐるみ",
    "name_en": "Valentine Bunny Plush",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_7"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_41_valentine_day_8_sidetable_a",
    "name_jp": "バレンタインギフトボックス",
    "name_en": "Valentine Gift Box",
    "tags": ["event_gacha_only", "living", "41_valentine_day", "slot_8"],
    "room": "living",
    "theme": "41_valentine_day",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-11T15:00:00.000Z",
    "priority": 56,
    "image": "01_living_room/41_valentine_day/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_42_spring_tea_party_1_wallpaper_a",
    "name_jp": "春のパーティー壁紙",
    "name_en": "Spring Party Wallpaper",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_1"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_42_spring_tea_party_2_floor_a",
    "name_jp": "春のパーティーラグ",
    "name_en": "Spring Party Rug",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_2"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_42_spring_tea_party_3_above_fireplace_a",
    "name_jp": "春の妖精",
    "name_en": "Spring Fairy",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_3"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_42_spring_tea_party_4_painting_a",
    "name_jp": "春の壁掛け時計",
    "name_en": "Spring Wall Clock",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_4"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_42_spring_tea_party_5_fireplace_a",
    "name_jp": "春のティーポット",
    "name_en": "Spring Teapot",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_5"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_42_spring_tea_party_6_tree_a",
    "name_jp": "春のスイーツセット",
    "name_en": "Spring Sweets Set",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_6"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_42_spring_tea_party_7_couch_a",
    "name_jp": "春色テーブル",
    "name_en": "Spring Color Table",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_7"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_42_spring_tea_party_8_sidetable_a",
    "name_jp": "春のオルゴール",
    "name_en": "Spring Orgel",
    "tags": ["event_gacha_only", "living", "42_spring_tea_party", "slot_8"],
    "room": "living",
    "theme": "42_spring_tea_party",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-02-27T15:00:00.000Z",
    "priority": 57,
    "image": "01_living_room/42_spring_tea_party/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_43_easter_egg_hunt_1_wallpaper_a",
    "name_jp": "イースターの木目壁紙",
    "name_en": "Easter Wood Wallpaper",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_1"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_43_easter_egg_hunt_2_floor_a",
    "name_jp": "春の草原ラグ",
    "name_en": "Spring Meadow Rug",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_2"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_43_easter_egg_hunt_3_above_fireplace_a",
    "name_jp": "エッグネスト飾り",
    "name_en": "Egg Nest Decoration",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_3"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_43_easter_egg_hunt_4_painting_a",
    "name_jp": "フラワーポットアート",
    "name_en": "Flower Pot Art",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_4"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_43_easter_egg_hunt_5_fireplace_a",
    "name_jp": "イースターティーマグ",
    "name_en": "Easter Tea Mug",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_5"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_43_easter_egg_hunt_6_tree_a",
    "name_jp": "カラフルエッグタワー",
    "name_en": "Colorful Egg Tower",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_6"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_43_easter_egg_hunt_7_couch_a",
    "name_jp": "うさぎのぬいぐるみ",
    "name_en": "Bunny Plush",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_7"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_43_easter_egg_hunt_8_sidetable_a",
    "name_jp": "イースターエッグバスケット",
    "name_en": "Easter Egg Basket",
    "tags": ["event_gacha_only", "living", "43_easter_egg_hunt", "slot_8"],
    "room": "living",
    "theme": "43_easter_egg_hunt",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-03-30T15:00:00.000Z",
    "priority": 58,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_44_golden_week_day_1_wallpaper_a",
    "name_jp": "青空と海の壁紙",
    "name_en": "Blue Sky & Ocean Wallpaper",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_1"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_44_golden_week_day_2_floor_a",
    "name_jp": "ロードトリップラグ",
    "name_en": "Road Trip Rug",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_2"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_44_golden_week_day_3_above_fireplace_a",
    "name_jp": "旅行の思い出フレーム",
    "name_en": "Travel Memory Frame",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_3"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_44_golden_week_day_4_painting_a",
    "name_jp": "旅のスケジュールボード",
    "name_en": "Travel Schedule Board",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_4"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_44_golden_week_day_5_fireplace_a",
    "name_jp": "旅するマグカップ",
    "name_en": "Travel Mug",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_5"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_44_golden_week_day_6_tree_a",
    "name_jp": "観光ポストサイン",
    "name_en": "Travel Signpost",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_6"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_44_golden_week_day_7_couch_a",
    "name_jp": "レトロキャンピングカー",
    "name_en": "Retro Camper Van",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_7"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_44_golden_week_day_8_sidetable_a",
    "name_jp": "トラベルスーツケース",
    "name_en": "Travel Suitcase",
    "tags": ["event_gacha_only", "living", "44_golden_week", "slot_8"],
    "room": "living",
    "theme": "44_golden_week",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-04-29T15:00:00.000Z",
    "priority": 59,
    "image": "01_living_room/44_golden_week/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a",
    "name_jp": "雨空の壁紙",
    "name_en": "Rainy Sky Wallpaper",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_1"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_2_floor_a",
    "name_jp": "ウッドフロアラグ",
    "name_en": "Wooden Floor Rug",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_2"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a",
    "name_jp": "あじさいのリース",
    "name_en": "Hydrangea Wreath",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_3"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_4_painting_a",
    "name_jp": "雨音ランプ",
    "name_en": "Rainy Lamp",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_4"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_5_fireplace_a",
    "name_jp": "ブックカフェマグ",
    "name_en": "Book Cafe Mug",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_5"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_6_tree_a",
    "name_jp": "ナチュラルブックシェルフ",
    "name_en": "Natural Bookshelf",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_6"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_7_couch_a",
    "name_jp": "リーディングチェア",
    "name_en": "Reading Chair",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_7"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_8_sidetable_a",
    "name_jp": "ブックスタックテーブル",
    "name_en": "Book Stack Table",
    "tags": ["event_gacha_only", "living", "45_rainyseason_bookcafe", "slot_8"],
    "room": "living",
    "theme": "45_rainyseason_bookcafe",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-05-29T15:00:00.000Z",
    "priority": 60,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_46_tropical_island_vacation_day_1_wallpaper_a",
    "name_jp": "トロピカルビーチの壁紙",
    "name_en": "Tropical Beach Wallpaper",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_1"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_46_tropical_island_vacation_day_2_floor_a",
    "name_jp": "砂浜のラグ",
    "name_en": "Sandy Beach Rug",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_2"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_46_tropical_island_vacation_day_3_above_fireplace_a",
    "name_jp": "トロピカルフルーツボウル",
    "name_en": "Tropical Fruit Bowl",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_3"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_46_tropical_island_vacation_day_4_painting_a",
    "name_jp": "夕暮れのビーチアート",
    "name_en": "Sunset Beach Painting",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_4"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_46_tropical_island_vacation_day_5_fireplace_a",
    "name_jp": "トロピカルビーチバー",
    "name_en": "Tropical Beach Bar",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_5"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_46_tropical_island_vacation_day_6_tree_a",
    "name_jp": "南国のヤシの木",
    "name_en": "Tropical Palm Tree",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_6"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_46_tropical_island_vacation_day_7_couch_a",
    "name_jp": "ビーチチェアセット",
    "name_en": "Beach Chair Set",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_7"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_46_tropical_island_vacation_day_8_sidetable_a",
    "name_jp": "ティキサイドテーブル",
    "name_en": "Tiki Side Table",
    "tags": [
      "event_gacha_only",
      "living",
      "46_tropical_island_vacation",
      "slot_8"
    ],
    "room": "living",
    "theme": "46_tropical_island_vacation",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-06-29T15:00:00.000Z",
    "priority": 61,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_47_seashell_day_1_wallpaper_a",
    "name_jp": "海の壁紙",
    "name_en": "Underwater Wallpaper",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_1"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_47_seashell_day_2_floor_a",
    "name_jp": "サンゴ礁のラグ",
    "name_en": "Coral Reef Rug",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_2"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_47_seashell_day_3_above_fireplace_a",
    "name_jp": "シェルシャンデリア",
    "name_en": "Seashell Chandelier",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_3"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_47_seashell_day_4_painting_a",
    "name_jp": "海底の風景画",
    "name_en": "Underwater Landscape Painting",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_4"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_47_seashell_day_5_fireplace_a",
    "name_jp": "シェルティーポット",
    "name_en": "Seashell Teapot",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_5"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_47_seashell_day_6_tree_a",
    "name_jp": "サンゴのオブジェ",
    "name_en": "Coral Display",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_6"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_47_seashell_day_7_couch_a",
    "name_jp": "シェルソファ",
    "name_en": "Seashell Sofa",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_7"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_47_seashell_day_8_sidetable_a",
    "name_jp": "シェルサイドテーブル",
    "name_en": "Seashell Side Table",
    "tags": ["event_gacha_only", "living", "47_seashell", "slot_8"],
    "room": "living",
    "theme": "47_seashell",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-07-30T15:00:00.000Z",
    "priority": 62,
    "image": "01_living_room/47_seashell/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_48_early_autumn_picnic_day_1_wallpaper_a",
    "name_jp": "初秋の野原の壁紙",
    "name_en": "Early Autumn Meadow Wallpaper",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_1"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_48_early_autumn_picnic_day_2_floor_a",
    "name_jp": "コスモスの草原ラグ",
    "name_en": "Cosmos Meadow Rug",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_2"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_48_early_autumn_picnic_day_3_above_fireplace_a",
    "name_jp": "ぶどうのピクニックテーブル",
    "name_en": "Green Apple Embroidery",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_3"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_48_early_autumn_picnic_day_4_painting_a",
    "name_jp": "青りんごの刺繍飾り",
    "name_en": "Grape Picnic Table",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_4"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_48_early_autumn_picnic_day_5_fireplace_a",
    "name_jp": "バスケットカップ",
    "name_en": "Picnic Basket House",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_5"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_48_early_autumn_picnic_day_6_tree_a",
    "name_jp": "秋のりんごの木",
    "name_en": "Autumn Apple Tree",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_6"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_48_early_autumn_picnic_day_7_couch_a",
    "name_jp": "ピクニックチェア",
    "name_en": "Pink Picnic Chair",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_7"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_48_early_autumn_picnic_day_8_sidetable_a",
    "name_jp": "ピクニックバスケット",
    "name_en": "Picnic Basket",
    "tags": ["event_gacha_only", "living", "48_early_autumn_picnic", "slot_8"],
    "room": "living",
    "theme": "48_early_autumn_picnic",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-08-30T15:00:00.000Z",
    "priority": 63,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  },
  {
    "id": "living_49_pumpkin_farm_day_1_wallpaper_a",
    "name_jp": "秋のファームの壁紙",
    "name_en": "Autumn Farm Wallpaper",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_1"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 1,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_wallpaper.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_49_pumpkin_farm_day_2_floor_a",
    "name_jp": "落ち葉の小道ラグ",
    "name_en": "Fallen Leaves Path Rug",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_2"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 2,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_floor.png",
    "currency": "gems",
    "price": 1250
  },
  {
    "id": "living_49_pumpkin_farm_day_3_above_fireplace_a",
    "name_jp": "パンプキンランタン",
    "name_en": "Pumpkin Lantern",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_3"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 3,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_above_fireplace.png",
    "currency": "gems",
    "price": 1000
  },
  {
    "id": "living_49_pumpkin_farm_day_4_painting_a",
    "name_jp": "松ぼっくりのリース",
    "name_en": "Pinecone Wreath",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_4"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 4,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/04_painting.png",
    "currency": "gems",
    "price": 750
  },
  {
    "id": "living_49_pumpkin_farm_day_5_fireplace_a",
    "name_jp": "パンプキンハウス",
    "name_en": "Pumpkin House",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_5"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 5,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/05_fireplace.png",
    "currency": "gems",
    "price": 2500
  },
  {
    "id": "living_49_pumpkin_farm_day_6_tree_a",
    "name_jp": "パンプキンかかし",
    "name_en": "Pumpkin Scarecrow",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_6"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 6,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/06_tree.png",
    "currency": "gems",
    "price": 1500
  },
  {
    "id": "living_49_pumpkin_farm_day_7_couch_a",
    "name_jp": "ウッドガーデンチェア",
    "name_en": "Wooden Garden Chair",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_7"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 7,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/07_couch.png",
    "currency": "gems",
    "price": 2000
  },
  {
    "id": "living_49_pumpkin_farm_day_8_sidetable_a",
    "name_jp": "パンプキンスイーツスタンド",
    "name_en": "Pumpkin Sweets Stand",
    "tags": ["event_gacha_only", "living", "49_pumpkin_farm", "slot_8"],
    "room": "living",
    "theme": "49_pumpkin_farm",
    "slot": 8,
    "max_tier": 3,
    "color": "a",
    "release_date": "2026-09-30T12:00:00.000Z",
    "priority": 64,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/08_sidetable.png",
    "currency": "gems",
    "price": 250
  }
]
